import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';
import { ProductIcon } from '../../../../product/icon/ProductIcon';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radius-large);
    height: var(--MenuProductCardIcon-container-size);
    width: var(--MenuProductCardIcon-container-size);
    min-width: var(--MenuProductCardIcon-container-size);
    overflow: hidden;
    transform: translateZ(0);

    &.isIcon {
        border-radius: 0;
    }

    &.isLarge {
        height: var(--MenuProductCardIcon-container-size-large);
        width: var(--MenuProductCardIcon-container-size-large);
        min-width: var(--MenuProductCardIcon-container-size-large);

        //svg {
        //    height: calc(var(--MenuProductCardIcon-container-size-large) - 2 * var(--ui-spacing));
        //    width: calc(var(--MenuProductCardIcon-container-size-large) - 2 * var(--ui-spacing));
        //}
    }

    svg {
        height: var(--MenuProductCardIcon-container-size);
        width: var(--MenuProductCardIcon-container-size);
        fill: var(--x-color-secondary);
    }
`;

interface Props {
    icon: any;
    isLarge?: boolean;
}

export function MenuProductCardIcon({ icon, isLarge }: Props) {
    const isImage =
        icon?.startsWith?.('http') && !icon.startsWith('https://s3-eu-west-1.amazonaws.com/orderx-images/products');

    return (
        <Wrapper className={clsx('MenuProductCardIcon', { isLarge: isLarge || isImage, isImage, isIcon: !isImage })}>
            <ProductIcon icon={icon} />
        </Wrapper>
    );
}
